import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'intervalMin'
})
export class IntervalMinPipe implements PipeTransform {
    transform(value: number): string {
        if(value >= 0){
            const min = value % 60;
            return this.double(min);
        } else {
            return '- -';
        }
    }

    private double(val: number): string {
        return val / 10 >= 1 ? val.toString() : '0' + val;
    }
}
